export default __webpack_public_path__ + "static/media/Listar.635cb084.svg";